export type StatusActionClassificationInput = {
  CHILDREN?: { UUID_OBJECT: string }[]
}

export type TaskStatusActionsResult<T> = {
  displayedStatusActions: T[]
  showOnlyVisualizeButton: boolean
}

type StatusActionLike = {
  uuid: string
  destination_status?: { code: string }[]
}

export function computeTaskStatusActions<T extends StatusActionLike>(
  statusActions: T[],
  classification?: StatusActionClassificationInput
): TaskStatusActionsResult<T> {
  if (!classification) {
    return {
      displayedStatusActions: statusActions.filter(
        (sa) => sa.destination_status?.[0] !== undefined
      ),
      showOnlyVisualizeButton: false
    }
  }

  const children = classification.CHILDREN ?? []
  if (children.length === 0) {
    return {
      displayedStatusActions: [],
      showOnlyVisualizeButton: true
    }
  }

  const byUuid = new Map(statusActions.map((sa) => [sa.uuid, sa]))
  const displayedStatusActions = children
    .map((child) => byUuid.get(child.UUID_OBJECT))
    .filter(
      (sa): sa is T =>
        sa !== undefined && sa.destination_status?.[0] !== undefined
    )

  return {
    displayedStatusActions,
    showOnlyVisualizeButton: displayedStatusActions.length === 0
  }
}
